export function getArtworkEditionText(artwork: any): string {
  const rawValue =
    artwork?.LtdNumber ??
    artwork?.edition_number ??
    artwork?.EditionNumber ??
    artwork?.Edition ??
    artwork?.edition ??
    "";

  return typeof rawValue === "string" ? rawValue.trim() : String(rawValue || "").trim();
}
